import "core-js/modules/es.array.push.js";
import { questionnaireExamineListData } from './request';
export default {
  data() {
    return {
      form: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'serialNo',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '问卷名称'
        },
        dataIndex: 'questionnaireName',
        key: 'questionnaireName',
        align: 'center'
      }, {
        slots: {
          title: '归属客户'
        },
        dataIndex: 'customerName',
        key: 'customerName',
        align: 'center'
      }, {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: 'userName',
        align: 'center'
      }, {
        slots: {
          title: '审核状态'
        },
        dataIndex: 'status',
        key: '10',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: 'updateAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 220,
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await questionnaireExamineListData(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        type: 'all'
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.data = [];
      this.getDataFun();
    },
    // 操作按钮：审核 查看
    handleEdit(record) {
      console.log(record, '----------');
      this.$router.push({
        name: 'questionnaireReview',
        params: {
          id: record.id,
          auditFlowTypeId: record.auditFlowTypeId
        }
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    }
  }
};